/**
 * Проверяет, выполняется ли код внутри iframe.
 * @returns {boolean} Возвращает true, если код выполняется внутри iframe, иначе false.
 */
const isIframe = () => typeof window !== 'undefined' && window.location !== window.parent.location;
/**
 * Проверяет, выполняется ли код внутри iframe в котором подключен iframe-resizer
 * https://github.com/davidjbradshaw/iframe-resizer
 * @returns {boolean} Возвращает true, если код выполняется внутри iframe c iframe-resizer, иначе false.
 */
const isIframeWithIframeResizer = () => isIframe() && window?.parentIFrame !== undefined;

export { isIframe, isIframeWithIframeResizer };
//# sourceMappingURL=isIframe.js.map
